import useInView from "./useInView";

// Tailwind'in derleme sırasında görmesi için sınıflar tam yazılır.
const ANIMATIONS = {
  in: "animate-hero-in",
  pop: "animate-pop-in",
  rise: "animate-rise-in",
  quote: "animate-quote-in",
};

/**
 * Kaydırınca görünür alana giren öğeyi bir kez canlandırır. Görünene kadar
 * yalnız opacity-0 durur; hareket azaltılmışsa ya da gözlemci hiç
 * tetiklenmezse (useInView'deki 4 sn yedeği) içerik yine görünür olur.
 * `inView` verilirse kendi gözlemcisi yerine dıştaki durumu kullanır.
 */
export default function Reveal({
  as: Tag = "div",
  animation = "in",
  delay = 0,
  threshold = 0.2,
  inView: outerInView,
  className = "",
  style,
  children,
  ...rest
}) {
  const [ref, ownInView] = useInView({ threshold });
  const shown = outerInView ?? ownInView;
  const motion = shown
    ? `${ANIMATIONS[animation] || ANIMATIONS.in} motion-reduce:animate-none`
    : "opacity-0 motion-reduce:opacity-100";

  return (
    <Tag
      ref={outerInView === undefined ? ref : undefined}
      className={`${motion} ${className}`}
      style={{ animationDelay: `${delay}s`, ...style }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
